export const convertCreateBonusGift = data => {
  // const image = data.imageData.image.split(',')[1];
  const image = data.imageData.image;
  const level = data.levelItems.find(v => v.active)?.value ?? '';
  const status = data.statusItems.find(v => v.active)?.value ?? '';
  const type = data.typeItems.find(v => v.active)?.value ?? '';

  const bodyData = new FormData();
  bodyData.append('gift_name', data.name);
  bodyData.append('gift_coin_cost', Number(data.points));
  bodyData.append('gift_stricoin_level', level);
  bodyData.append('gift_type', type);
  bodyData.append(type === 'REAL_BALANCE' ? 'gift_money_to_balance' : 'gift_promo_code', data.promocodeOrAmount);
  if (image) bodyData.append('gift_image', image);
  if (data.id) bodyData.append('id', data.id);
  bodyData.append('gift_status', status);

  return bodyData;

}
